import React, { Fragment } from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { withRouter } from 'react-router';

const ViewQuizSummaryAction = ({
  quizSummaryId,
  router: { location },
  router,
  closePopUp,
  disabled,
}) => {
  const { query, state, pathname } = location;

  const handleClick = (event) => {
    event.stopPropagation();
    router.push({
      pathname,
      query: { ...query, quizSummaryId },
      state: { ...state, isQuizSummary: true },
    });
    closePopUp && closePopUp();
  };
  return (
    <Fragment>
      <AccessibilityWrapper>
        <SingleAction
          tabIndex={0}
          onClick={handleClick}
          iconName="quiz_summary"
          disabled={disabled}
        >
          <span className="item-text">View Quiz Summary</span>
        </SingleAction>
      </AccessibilityWrapper>
    </Fragment>
  );
};

export default withRouter(ViewQuizSummaryAction);
